<template>
    <div class="lms__user_achievements_rules">
        <component-text>{{ $t('lms.user.achievements.text.HereYouCanSetupTheTasks') }}</component-text>
        <form-ruleform
            ref="ruleform"
            :rules-is-root="true"
            :rules="achievementRules"
            :disabled="achievementDefaultStatus === 'active'"
            @emit-add="addRule"
            @emit-remove="removeRule"
            @emit-rules-value="setRulesValue"
        />
        <form-submit
            ref="formsubmit"
            @reset="performReset"
            @submit="performSubmitValidate"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import FormSubmit from '@/components/default/forms/FormSubmit'
import ComponentText from '@/components/default/shared/ComponentText'
import FormRuleform from '@/components/default/forms/FormRuleform'
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'lms-user-achievements-edit-rules',
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  components: { PopNotify, FormSubmit, FormRuleform, ComponentText },
  data () {
    return {
      holdEmitRulesValue: false
    }
  },
  computed: {
    achievementDefaultStatus () {
      return this.$store.getters.getLmsUserAchievementDefaultStatus
    },
    achievementRules: {
      get () {
        return this.$store.getters.getLmsUserAchievementRule
      }
    },
    //
    watchContent () {
      return this.achievementRules
    },
    //
    rootItemName () {
      return 'achievement'
    },
    nameActionCreate () {
      return 'lmsUserAchievementCreate'
    },
    nameActionUpdate () {
      return 'lmsUserAchievementUpdate'
    },
    nameActionReset () {
      return 'lmsUserAchievementReset'
    }
  },
  methods: {
    addRule (data) {
      this.$store.dispatch('lmsUserAchievementAddRule', data)
    },
    removeRule (data) {
      this.$store.dispatch('lmsUserAchievementRemoveRule', data)
    },
    setRulesValue (data) {
      if (this.holdEmitRulesValue) return
      if (data.key === 'rule' && data.value.value !== 'SubsetExpression') {
        this.$store.dispatch('lmsUserAchievementSetRuleValue', { indexes: data.indexes, key: 'threshold', value: 0 })
      }
      this.$store.dispatch('lmsUserAchievementSetRuleValue', data)
      this.holdEmitRulesValue = true
      setTimeout(() => {
        this.holdEmitRulesValue = false
      }, 100)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/achievements/_lmsuserachievementseditrules";
</style>
